import { mockZelleAccountIneligibleResponse } from 'features/moveMoney/mocks/zelleSSOTokenMock';

import { MockHandler, MockHandlers } from './utils/mockUtils';

export const mockHandlers: MockHandlers = {
  ZelleSSOToken: () => mockZelleAccountIneligibleResponse,
};

// Helper functions for runtime handler management
export const addMockHandler = (
  operationName: string,
  handler: MockHandler,
): void => {
  mockHandlers[operationName] = handler;
};

export const removeMockHandler = (operationName: string): void => {
  delete mockHandlers[operationName];
};

export const hasMockHandler = (operationName: string): boolean => {
  return operationName in mockHandlers;
};

export const clearMockHandlers = (): void => {
  Object.keys(mockHandlers).forEach((key) => delete mockHandlers[key]);
};
